/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceTimelineEventPayload } from './';
import {
    ComplianceTimelineEventPayloadFromJSON,
    ComplianceTimelineEventPayloadFromJSONTyped,
    ComplianceTimelineEventPayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface KycDocumentStoredEventTimelinePayload
 */
export interface KycDocumentStoredEventTimelinePayload extends ComplianceTimelineEventPayload {
    /**
     * 
     * @type {string}
     * @memberof KycDocumentStoredEventTimelinePayload
     */
    kycDocumentId: string;
    /**
     * 
     * @type {string}
     * @memberof KycDocumentStoredEventTimelinePayload
     */
    kycDocumentType: string;
    /**
     * 
     * @type {string}
     * @memberof KycDocumentStoredEventTimelinePayload
     */
    source: string;
}

/**
 * Check if a given object implements the KycDocumentStoredEventTimelinePayload interface.
 */
export function instanceOfKycDocumentStoredEventTimelinePayload(value: object): value is KycDocumentStoredEventTimelinePayload {
    if (!('kycDocumentId' in value) || value['kycDocumentId'] === undefined) return false;
    if (!('kycDocumentType' in value) || value['kycDocumentType'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function KycDocumentStoredEventTimelinePayloadFromJSON(json: any): KycDocumentStoredEventTimelinePayload {
    return KycDocumentStoredEventTimelinePayloadFromJSONTyped(json, false);
}

export function KycDocumentStoredEventTimelinePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): KycDocumentStoredEventTimelinePayload {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadFromJSONTyped(json, ignoreDiscriminator),
        'kycDocumentId': json['kycDocumentId'],
        'kycDocumentType': json['kycDocumentType'],
        'source': json['source'],
    };
}

export function KycDocumentStoredEventTimelinePayloadToJSON(value?: KycDocumentStoredEventTimelinePayload | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadToJSON(value, true),
        'kycDocumentId': value['kycDocumentId'],
        'kycDocumentType': value['kycDocumentType'],
        'source': value['source'],
    };
}

